import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import TabContent from "../TabContent";

const WorkTabContent = () => {
  
  return (
    <Tabs className="work-tab">
      <TabList>
        <Tab>Letsee, Inc.</Tab>
        <Tab>KIST</Tab>
        <Tab>Konkuk University</Tab>
        <Tab>Enclave ODC</Tab>
      </TabList>

      <TabPanel>
        <TabContent
          role={"Engineer"}
          companyName={'Letsee, Inc.'}
          companyWebsite={"https://www.letsee.io/"}
          period={"Jan 2019 - Present"}
          details={[
            {
              id: 1,
              content: "Develop a 3D Editor which allows user flexible creates and publishes WebAR content cross-browser.",
            },
            {
              id: 2,
              content: "Build WebXR applications using 8thwall, Letsee SDK and variety of different languages such as React.js, R3F and Node.js.",
            },
            {
              id: 3,
              content: "Work with 3D rendering engines such as Three.js, A-Frame and WebGL to make WebXR apps.",
            },
            {
              id: 4,
              content: "Build web applications from ideation to release, ensure to meet the business requirements and a high degree of maintainability.",
            },
          ]}
        />
      </TabPanel>
      <TabPanel>
        <TabContent
          role={"Research Assistant"}
          companyName={"KIST | MR Lab"}
          companyWebsite={"https://sites.google.com/view/mrlabkist/home"}
          period={"Jan 2017 - Dec 2018"}
          details={[
            {
              id: 1,
              content:
                "Researched and worked on projects related to Mixed Reality, Virtual Human, Animations/Emotions and Machine Learning.",
            },
            {
              id: 2,
              content:
                "Developed several prototypes for virtual human to apply object recognition and spatial mapping in virtual environment.",
            },
          ]}
        />
      </TabPanel>
      <TabPanel>
        <TabContent
          role={"Research Assistant"}
          companyName={"Konkuk University | HCI Lab"}
          companyWebsite={"https://eng.konkuk.ac.kr/"}
          period={"Aug 2016 - Mar 2017"}
          details={[
            {
              id: 1,
              content:
                "Developed prototype using Weight Perception Framework in Virtual Environment for Hemiparesis Rehabilitation.",
            },
            {
              id: 2,
              content:
                "Built a segmentation tool for analyzing pet’s behaviors through the video capture Arduino sensor.",
            },
            {
              id: 3,
              content:
                "Built an AR web application hand gestures to support studying 3D Geometry.",
            },
            {
              id: 4,
              content:
                "Developed a web application using hand gestures to support disabled people to control web browser.",
            },
          ]}
        />
      </TabPanel>
      <TabPanel>
        <TabContent
          role={"Engineer"}
          companyName={"Enclave ODC"}
          companyWebsite={"https://enclaveit.com/"}
          period={"Jul 2011 - Aug 2014"}
          details={[
            {
              id: 1,
              content:
                "Worked on a proxy web-service application community between DataGravity CRM’s system, Salesforces.com and AWS Amazon S3.",
            },
            {
              id: 2,
              content:
                "Configured a web application for Smart Home Control Monitoring System with GeminiAPI.",
            },
            {
              id: 3,
              content:
                "Worked on a web application to manage automatic back-end procurement’s activities using ADF framework and Oracle E-Business Suite.",
            },
          ]}
        />
      </TabPanel>
    </Tabs>
  );
};

export default WorkTabContent;
